import type { Filetype } from '@frameio/graphql-client/generated/types';
import type { QuickSearchAssetV2Fragment } from '../gql/generated/QuickSearchAssetV2';
import TEXT from './generated/TEXT/getFileType';

TEXT.DEFINE({
  /** Label for the audio filetype */
  audio: 'Audio',
  /** Label for the compressed filetype */
  compressed: 'Compressed',
  /** Label for the drawing filetype */
  drawing: 'Drawing',
  /** Label for the generic file filetype */
  file: 'File',
  /** Label for folder file type */
  folder: 'Folder',
  /** Label for the image filetype */
  image: 'Image',
  /** Label for the interactive filetype */
  interactive: 'Interactive',
  /** Label for the interactive live filetype */
  interactiveLive: 'Web URL',
  /** Label for the 3D model filetype */
  model: 'Model',
  /** Label for the motion filetype */
  motion: 'Motion',
  /** Label for the pdf filetype */
  pdf: 'PDF',
  /** Label for the project filetype */
  project: 'Project',
  /** Label for the spreadsheet filetype */
  spreadsheet: 'Spreadsheet',
  /** Label for the text filetype */
  text: 'Text',
  /** Label for the vector filetype */
  vector: 'Vector',
  /** Label for the video filetype */
  video: 'Video',
});

const FILETYPE_LABELS: Partial<Record<Filetype, () => string>> = {
  AUDIO: () => TEXT.audio,
  COMPRESSED: () => TEXT.compressed,
  DRAWING: () => TEXT.drawing,
  FILE: () => TEXT.file,
  IMAGE: () => TEXT.image,
  INTERACTIVE: () => TEXT.interactive,
  INTERACTIVE_LIVE: () => TEXT.interactiveLive,
  MODEL: () => TEXT.model,
  MOTION: () => TEXT.motion,
  PDF: () => TEXT.pdf,
  PROJECT: () => TEXT.project,
  SPREADSHEET: () => TEXT.spreadsheet,
  TEXT: () => TEXT.text,
  VECTOR: () => TEXT.vector,
  VIDEO: () => TEXT.video,
};

export const getFileType = (data?: QuickSearchAssetV2Fragment) => {
  if (!data) return undefined;

  if (data.__typename === 'FolderAsset') {
    return { type: 'folder', label: TEXT.folder };
  }

  if ('typeOfFile' in data && data.typeOfFile != null) {
    return {
      type: data.typeOfFile.toLowerCase(),
      label: (FILETYPE_LABELS[data.typeOfFile] ?? (() => TEXT.file))(),
    };
  }

  return undefined;
};
